import { Button } from "../../Button";

import {
  Container,
  DecorationLeft,
  Content,
  Image,
  MainContent,
  Title,
  Description,
} from "./styles";

export const Desktop = ({ image, title, description, onAction }) => {
  return (
    <Container>
      <DecorationLeft />
      <Content>
        <Image src={image} alt="" />
        <MainContent>
          <Title class="assessment-count">{title}</Title>
          <Description>{description}</Description>
          <Button onClick={onAction}>Talk to us now</Button>
        </MainContent>
      </Content>
    </Container>
  );
};
